module.exports = __webpack_public_path__ + "img/06-2.b7c70e24.png";